// extracted by mini-css-extract-plugin
module.exports = {"padded":"Profile_padded__22w6B"};